import { BentResponse } from 'bent';
import { httpClient } from 'utils/httpClient';

const url = process.env.REACT_APP_CLINICIAN_PROFILE_SERVICE_URL;

export const getDecryptedDocument = (token: string, bucketName: string, fileName: string) =>
  httpClient('GET', url!, 200, { Authorization: `Bearer ${token}` })(
    `/download/encrypted?bucketName=${bucketName}&fileName=${fileName}`
  ) as Promise<BentResponse>;
